import { InfoTooltip, PriceString } from '@fourthwall/components';
import React from 'react';
import * as S from './SamplesCreditBalance.styled';
export const SamplesCreditBalance = ({ label, balance, tooltip }) => (React.createElement(S.Container, null,
    label,
    ": ",
    React.createElement(PriceString, { value: balance.value, currency: balance.currency }),
    tooltip && (React.createElement(S.TooltipContainer, null,
        React.createElement(InfoTooltip, { content: tooltip })))));
